<nb-toggle  [checked]="true" labelPosition="start">Contact Number</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">Email Link</nb-toggle>
